module.exports = __webpack_public_path__ + "img/closeEye.0a2e5e7c.png";